import AIBanner from './AIBanner';

export default AIBanner;
